import React from "react";
import "./MediaAsset.css";
import Tab from 'react-bootstrap/Tab';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Footer from "../../component/footer";

// import Sonnet from '../../component/';
const MediaAsset = () => {
  return (
    <div className='mediaAsset'>
      <section className='banner-mas'>
        <div className='bar-cs1-mass'>
          <div className='container-1200'>
            <div className='row'>
              <div className='col-lg-12'>
                <span className='img-cs1-mas'>
                  <img src={require("../../Assets/img/cube-mas.png")} alt='' />
                </span>
                <span className='img-cs11-mas'>
                  <img src={require("../../Assets/img/rubix-mas.png")} alt='' />
                </span>
                <h1>Brand</h1>
                <h2> Overview</h2>
                <span className='img-cs2-mas'>
                  <img src={require("../../Assets/img/game1-mas.png")} alt='' />
                </span>

                <span className='img-cs22-mas'>
                  <img
                    src={require("../../Assets/img/cube-g-mas.png")}
                    alt=''
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='brand-txt-sec'>
        <div className='container-1200'>
          <div className='row'>
            <div className='col-lg-12'>
              <h3> Brand Guidelines And Assets</h3>
              <div className='container-1085'>
                <p>
                  Anyone using King’s Charts’ assets must only use the
                  screenshots and logos available on our Brand Resource Center
                  webpage and adhere to the guidelines provided.
                </p>
                <p>
                  {" "}
                  Only those who intend to use King’s Charts’ assets in any
                  radio, broadcast, print, or out-of-home advertisement larger
                  than 8.5 x 11 inches (A4 size) must request access. Permission
                  requests must be written in English and include a mock-up of
                  how the brand's logo will be used.
                </p>
                <p>
                  {" "}
                  Anyone using King’s Charts’ assets must only use the
                  screenshots and logos available on our Brand Resource Center
                  webpage and adhere to the guidelines provided.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section className='download-section-mas'>
        <div className='container-1200'>
          <div className='download-flex-mas'>
            <div className='img-mas'>
              <img src={require("../../Assets/img/logo-circle.png")} alt='' />
            </div>
            <div className='txt-mas'>
              <h4>Download Logo Pack</h4>
              <div className='check-mas'>
                <label>
                  <input type='checkbox' value='' />
                  <span>
                    I have read and accept the applicable guidelines and other
                    terms for use.
                  </span>
                </label>
              </div>
            </div>

            <div className='img-down-mas'>
              <img src={require("../../Assets/img/down-mass.png")} alt='' />
            </div>

           
          </div>
        </div>
      </section>


      <section className='infographics-section-mas'>
        <div className='container-1200'>
          <div className='infographics-flex-mas'>
            <div className='txt-mas'>
              <h4 className='f-70'>
                Design style and infographics for you to use
              </h4>
            </div>
            <div className='img-mas'>
              <img src={require("../../Assets/img/game-mass.png")} alt='' />
            </div>


            <span className='design-diamond'>
              <img src={require("../../Assets/img/design-mas.png")} alt='' />
            </span>
          </div>
        </div>
      </section>

      <section className="hz-media-tab-sec">
        <div className="container-1200">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <Row>
              <Col sm={3}>
                <Nav variant="pills" className="flex-column tabs-links-wrap">
                <button className="hz-linear-button" type="">BASICS</button>
                  <Nav.Item>
                    <Nav.Link eventKey="first" className="hz-tab-link">Master Logo</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="second"  className="hz-tab-link">Colors</Nav.Link>
                  </Nav.Item>
                  <h2>VISUAL ART</h2>
                  <Nav.Item>
                    <Nav.Link eventKey="third" className="hz-tab-link">Art Style</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="four" className="hz-tab-link">Founder Images</Nav.Link>
                  </Nav.Item>
                  <h2>Gaming Aracde</h2>
                  <Nav.Item>
                    <Nav.Link eventKey="" className="hz-tab-link">Gaming Arcade Logo</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="" className="hz-tab-link">Social Badges</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col sm={9}>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <div className="media-tab-inner-content">
                      <h2 className="hz-gradient-text">Master Logo</h2>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="logo-box">
                              <img src={require('../../Assets/img/logo1.png')} alt="" />
                              <h3>Logo Original</h3>
                          </div>
                        </div> 
                        <div className="col-md-6">
                          <div className="logo-box">
                              <img src={require('../../Assets/img/logo2.png')} alt="" />
                              <h3>Logo Original</h3>
                          </div>
                        </div> 
                      </div>
                      <div className="log-text">
                        <h2 className="hz-gradient-text">Vector</h2>
                        <img src={require('../../Assets/img/logobig.png')} alt="" />
                        <p>Gaming Arcade  Logo - Horizontal.svg</p>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <div className="media-tab-inner-content mtic-2">
                      <h2 className="hz-gradient-text">Logo Variations</h2>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="logo-box">
                            <div className="logo-grid-boxes">
                              <img src={require('../../Assets/img/color1.png')} alt="" />
                              <img src={require('../../Assets/img/color2.png')} alt="" />
                              <img src={require('../../Assets/img/color3.png')} alt="" />
                              <img src={require('../../Assets/img/color4.png')} alt="" />
                            </div>
                          </div>
                        </div> 
                        <div className="col-md-6">
                          <div className="logo-box">
                              <img src={require('../../Assets/img/color5.png')} alt="" />
                          </div>
                        </div> 
                        <div className="col-md-6">
                          <div className="logo-box">
                              <img src={require('../../Assets/img/color6.png')} alt="" />
                          </div>
                        </div> 
                        <div className="col-md-6">
                          <div className="logo-box">
                              <img src={require('../../Assets/img/logo2.png')} alt="" />
                          </div>
                        </div> 
                      </div>
                      <div className="row">
                          <div className="col-md-4">
                            <div className="color-copy-box">
                                <span className="color-box yellow-color"></span>
                                <div className="color-inner">
                                  <h3>Amber</h3>
                                  <p><span>HEX</span><span>#FFC000</span></p>
                                  <p><span>RGB</span><span>255, 192, 0</span></p>
                                  <p><span>SCSS</span><span>rgba(255, 192, 0, 1)</span></p>
                                </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="color-copy-box">
                                <span className="color-box red-color"></span>
                                <div className="color-inner">
                                  <h3>Red Pigment</h3>
                                  <p><span>HEX</span><span>#EC1C26</span></p>
                                  <p><span>RGB</span><span>236, 28, 38</span></p>
                                  <p><span>SCSS</span><span>rgba(236, 28, 38, 1)</span></p>
                                </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="color-copy-box">
                                <span className="color-box green-color"></span>
                                <div className="color-inner">
                                  <h3>Blue Munsell</h3>
                                  <p><span>HEX</span><span>#2491AE</span></p>
                                  <p><span>RGB</span><span>36, 145, 174</span></p>
                                  <p><span>SCSS</span><span>rgba(36, 145, 174, 1)</span></p>
                                </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="third">
                  <div className="media-tab-inner-content mtic-3">
                     <figure className="hz-figure-img">
                      <img src={require('../../Assets/img/art1.png')} alt="" />
                      <figcaption>Style 1.png</figcaption>
                     </figure>
                     <figure className="hz-figure-img">
                      <img src={require('../../Assets/img/art2.png')} alt="" />
                      <figcaption>Style 2.png</figcaption>
                     </figure>
                     <figure className="hz-figure-img">
                      <img src={require('../../Assets/img/art3.png')} alt="" />
                      <figcaption>Style 3.png</figcaption>
                     </figure>
                     <figure className="hz-figure-img">
                      <img src={require('../../Assets/img/art4.png')} alt="" />
                      <figcaption>Style 4.png</figcaption>
                     </figure>
                     <figure className="hz-figure-img">
                      <img src={require('../../Assets/img/art5.png')} alt="" />
                      <figcaption>Style 5.png</figcaption>
                     </figure>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="four">
                    <div className="media-tab-inner-content mtic-4">
                    <h2 className="hz-gradient-text">Founder Images</h2>
                      <div className="row justify-content-center">
                        <div className="col-md-5">
                          <div className="founder-profile">
                            <img src={require('../../Assets/img/founder1.png')} alt="" />
                          </div>
                          <h3>Ayush Khetan</h3>
                        </div>
                        <div className="col-md-5">
                          <div className="founder-profile">
                            {/* <img src={require('../../Assets/img/founder1.png')} alt="" /> */}
                          </div>
                          <h3>Karan Sharma</h3>
                        </div>
                        <div className="col-md-5">
                          <div className="founder-profile">
                            <img src={require('../../Assets/img/founder2.png')} alt="" />
                          </div>
                          <h3>Naveen Agarwal</h3>
                        </div>
                        <div className="col-md-5">
                          <div className="founder-profile">
                            <img src={require('../../Assets/img/founder3.png')} alt="" />
                          </div>
                          <h3>Abishek Tiwari</h3>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </section>

      <section className="utilize-sec">
        <div className="container-1200">
          <h2 className="hz-gradient-text">utilizing the brand</h2>   
          <p>Avoid using the brand image in ways that imply sponsorship, partnership, or make ZeltaTech the only prominent or distinguishing feature. Any context in a script or storyline that casts a negative light on the brand must be avoided. You must comply with our Community Guidelines and Terms of Service.</p>
          
         
        </div>
      </section>
      <section className="utilize-sec p-0 position-relative">
        <div className="container-1200">
          <div className="row align-items-center utilize-row">
              <div className="col-md-6">
                
              </div>
              <div className="col-md-6">
                <div className="utilize-content">
                  <h3>Consistency Assurance</h3>
                  <ul>
                    <li>Make sure the letters "K" and "C" are capitalised and in the same font style and size as the surrounding content. </li>
                    <li>If you create a website, an app, or a service or product that uses King’s Charts APIs or is otherwise related to or compatible with King’s Charts, you may only use King’s Charts in a descriptive manner to say that your app is "for King’s Charts" or that the name of your campaign is "on King’sCharts." </li>
                    <li>Do not attempt to translate, abbreviate, or modify the word King’sCharts into another language by using non-English characters, or replace it with one of our logos. </li>
                    <li>Do not use the words "Kings" or "Charts" in conjunction with your own brand.</li>
                    <li>Any aspect of the ZeltaTech brand should not be combined with a company name, generic terms, or other trademarks.</li>
                  </ul>
                </div>
              </div>
          </div>
        </div>
          <div className="utilize-box-text utilize-box-left">
            <h2>Avoid Shedding Negative Light</h2>
          </div>

      </section>
      <section className="utilize-sec p-0 position-relative">
        <div className="container-1200">
        <div className="row align-items-center utilize-row ur-2">
            <div className="col-md-6">
                <div className="utilize-content">
                  <p>Avoid representing the King’s Charts brand in ways where: </p>
                  <ul>
                    <li>King’sCharts may be mentioned in a TV commercial alongside King’sCharts companies or products. </li>
                    <li>Other blockchain/crypto/web3.0/De-Fi based platforms should not be mentioned alongside King’sCharts or its products, unless it is a general "Follow us on..." CTA.</li>
                    <li>If you create a hashtag that contains the words Kings or Charts, it should not be used on other social platforms, and no efforts should be made to enforce or acquire rights to that hashtag.</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
               
              </div>
          </div>
        </div>
          <div className="utilize-box-text utilize-box-right">
            <h2>Keep KingsCharts Apart From others blockchain/Crypto/Web3.0/De-Fi Based Platforms</h2>
          </div>
      </section>
      <section className="tvandfilms">
        <div className="container-1200">
          <div className="row">
            <div className="col-md-6 col-sm-7">
              <div className="tvfilm-content">
                <h2>using the <span className="hz-gradient-text"> gaming arcade</span> Brand in TV & Film</h2>
                <p>When using King’s Charts in mainstream media, it must be made sure that members of our community are given proper attribution for their content.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="laptop-img">
            <img src={require('../../Assets/img/laptop1.png')} alt="" />
          </div>
      </section>

      <section className="movie-commercial">
        <div className="container-1200">
          <div className="movie-com-content">
            <h2 className="text-left">Movies, Commercials <br /> & Shows</h2>
            <p className="text-left">If you plan to maintain your presence on King’s Charts in any of its products or use screenshots of King’s Charts and its products’ interface in a commercial, short film or movie, weekly show, TV or web series, and any other video, you need to follow our approval process. 
              <br/> <br />
              To do so, follow the steps given below.
            </p>
            
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="utilize-content">
                <button className="hz-step-button">Step 1</button>
                  <ul>
                    <li>If you want to use King’s Charts in a commercial, film, or show, send us the main part of the script as well as a mock-up of the King’sCharts asset. </li>
                    <li>If the usage is not clear enough, we may request to see the entire script. Submit your script for animation along with business development paintings and digital storyboards. </li>
                    <li>Please use only the assets that have been approved. When you first submit your request, we will respond within two to three weeks.</li>
                  </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="utilize-content">
                <button className="hz-step-button">Step 2</button>
                  <ul>
                    <li>Once the creatives, including your mock and script, are completed, submit the near-final version of our asset in your media. </li>
                    <li>When it comes to animation, the final clip must be uploaded once the animation is finished. </li>
                    <li>We will respond to you within two to three weeks after you submit your finalised creatives. </li>
                    <li>However, if seeking approval will take more than two to three weeks, you must revise your creative and resubmit your request while adhering to our guidelines. No approvals are final unless they are in writing.</li>
                  </ul>
              </div>
            </div>
          </div>
          <div className="movie-com-content">
            <h2>Legal</h2>
            <p>King’sCharts invests heavily in the protection and development of its intellectual property. We enforce our rights against individuals who misuse our trademarks in addition to seeking registration of its logos and trademarks around the world.</p>
            <p>King’sCharts’ trademarks are solely owned by King’sCharts and may only be used in accordance with the guidelines outlined above or with King'sCharts’ permission. Here is a list of a few of our trademarks.</p>
            <p>You are not permitted to register, use, or claim rights in any King’sCharts’ trademark, including as or as part of any service mark, trade name, trademark, company name, domain registration, or username. You must not claim or use any trademark rights in a way that is suspiciously similar to or dilutive of King'sCharts’ trademarks, including as, or as part of, a trademark. Use King'sCharts’ trademarks only for purposes that are consistent with its Community Standards or Terms of Service. </p>
            <p>We reserve the right, at any time, to revoke permission to use King'sCharts’ trademarks. King’sCharts reserves the right to refuse content that it deems inconsistent with the King’sCharts brand.</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};


export default MediaAsset;